import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { HeaderCopy, NavbarCopy } from '@models/cms/header.model';
import { RouterLinkActive, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { User } from '@models/user.model';
import { HeaderMenuUserComponent } from '../header-menu/header-menu-user/header-menu-user.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';

export interface NavItem {
  label: string;
  link?: string;
  onClick?: () => void;
  routerLinkActive?: boolean;
  icon?: string;
}

@Component({
  selector: 'app-top-navbar',
  standalone: true,
  imports: [RouterModule, CommonModule, RouterLinkActive, HeaderMenuUserComponent, AccordionModule],
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopNavbarComponent {
  navbarCopy = input.required<NavbarCopy>();
  cmsCopy = input.required<HeaderCopy>();
  loggedInUser = input<User | null>();
  currentValue = input<string>();

  bookClick = output<void>();
  openLoginModal = output<void>();
  logoutClick = output<void>();
  isMobile = input<boolean | null>(false);

  myTripsText = computed(() => {
    const value = this.currentValue();
    const copy = this.navbarCopy();

    switch (value) {
      case 'b':
        return copy.yourTrips;
      case 'c':
        return copy.myTrips;
      case 'd':
        return copy.myBooking;
      default:
        return copy.yourTrips;
    }
  });

  navItems = computed<NavItem[]>(() => [
    {
      label: this.cmsCopy().book.name,
      onClick: () => this.onBookClick(),
      icon: 'fa-kit fa-book'
    },
    {
      label: this.myTripsText(),
      link: this.cmsCopy().manageTrip.link,
      routerLinkActive: true,
      icon: 'fa-kit fa-your-trips'
    },
    {
      label: this.cmsCopy().flightStatus.name,
      link: this.cmsCopy().flightStatus.link,
      routerLinkActive: true,
      icon: 'fa-kit fa-flight-status'
    },
    {
      label: this.cmsCopy().support.name,
      link: this.cmsCopy().support.link,
      routerLinkActive: true,
      icon: 'fa-kit fa-support'
    }
  ]);

  onLogoutClick(): void {
    this.logoutClick.emit();
  }

  onBookClick(): void {
    this.bookClick.emit();
  }

  onLoginClick(): void {
    this.openLoginModal.emit();
  }
}
